import type { ReportFilterSelectOption } from '../../shared/report-filter-select-option.model';
import type { TraceUserInfoFacilityDto } from '../trace-user-info.types';

/**
 * Builds multiselect options: value = facility code (sent in Get-Agreements filter); label shows code and name.
 */
export function facilitiesToSelectOptions(
    facilities: readonly TraceUserInfoFacilityDto[] | null | undefined
): readonly ReportFilterSelectOption[] {
    if (!facilities?.length) {
        return [];
    }

    const seen = new Set<string>();
    const out: ReportFilterSelectOption[] = [];

    for (const f of facilities) {
        const code = f.code?.trim();
        if (!code || seen.has(code)) {
            continue;
        }
        seen.add(code);
        const name = f.name?.trim();
        out.push({
            value: code,
            label: name && name !== code ? `${code} — ${name}` : code,
        });
    }

    return out.sort((a, b) => a.value.localeCompare(b.value));
}
